module.exports = __webpack_public_path__ + "img/s1-1.18511599.jpg";